import { FunctionComponent, useCallback, useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ApolloError,
  useLazyQuery,
  useMutation,
  useQuery,
} from "@apollo/client";
import {
  PODS_DATA_ATTENDANCE,
  PROJECTS_BY_EMP_ID,
  SCREENS_BY_PROJECT,
  GET_ALL_SKILLS,
  POD_GOAL_TEMPLATES,
  EMPLOYEES_BY_AGENCY_ID, // TODO: query constant add karo api/query me (pod_goal_templates)
} from "../../api/query";
// TODO: confirm mutation name / variables with backend
import { CREATE_POD_GOAL, CREATE_POD_GOAL_CUSTOM } from "../../api/mutation";
// TODO: confirm the correct import path for the external supabase client
import BreadCumb from "../../components/common/Breadcrumb";
import Loader from "../../components/common/Loader";
import InputsNew from "../../components/common/InputsNew";
import DateSelector from "../../components/common/DateSelector";
import SearchableInputsDropdown from "../../components/common/SearchableDropdown";
import {
  showError,
  showSuccess,
} from "../../components/common/ToastNotification";
import backArrow from "../../assets/task/back_arrow.svg";
import aiAgenticon from "../../assets/kpi-items/profile-round-1342-svgrepo-com.svg";
import InputsDropdownMultipleSearchSelect from "../../components/common/InputsDropdownMultipleSearchSelect";
import closeDowpDowniconimg from "../../assets/task/closedropdown-cicon.svg";
import { getSupabaseExt } from "../../lib/supabase";

// ───────────────────────── Config (adjust as needed) ─────────────────────────
const AGENCY_ID = 3;
const ORGANIZATION_ID = "3";

// Template ke 3 fields store hote hain: id (key), name, tag
interface TemplateOption {
  key: string;
  name: string;
  tag: string;
}

// Agency field sirf in pods me dikhega (pod name lowercase me match hota hai).
// TODO: real rule confirm karo — empty array = kisi pod me nahi dikhega.
const PODS_WITH_AGENCY = ["client", "agency"];
const showAgencyForPod = (podName: string) =>
  PODS_WITH_AGENCY.some((p) => podName.toLowerCase().includes(p));

// Screen field sirf in templates me dikhega.
// TODO: real rule confirm karo.
const TEMPLATES_WITH_SCREEN = ["defect", "enhancement"];
// tag ya name dono me match check hota hai
const showScreenForTemplate = (tpl: TemplateOption | null) =>
  !!tpl &&
  TEMPLATES_WITH_SCREEN.some((t) =>
    `${tpl.tag} ${tpl.name}`.toLowerCase().includes(t),
  );

// TODO: confirm how admin is identified in userInfo
const checkIsAdmin = (userInfo: any) =>
  String(userInfo?.role || userInfo?.role_name || "")
    .toLowerCase()
    .includes("admin");

// TODO: confirm which field actually flags an agent slot on template tasks
const isAgentTask = (task: any) =>
  (task?.tag || "").toLowerCase().includes("agent") ||
  (task?.doer || "").toLowerCase().includes("agent");

// Agent-verified checklist items are never a human gate.
const isAgentChecklistItem = (kind: string) =>
  kind === "agent_lint" || kind === "agent_selfcheck";

interface Option {
  key: string;
  name: string;
}

interface TaskAssigneeState {
  employee_id: string;
  employee_name: string;
  task_start_date: string | null;
  task_end_date: string | null;
  duration_hours: string;
  duration_minutes: string;
}

interface TaskChecklistState {
  [checklistIndex: number]: boolean;
}

const emptyAssignee = (): TaskAssigneeState => ({
  employee_id: "",
  employee_name: "",
  task_start_date: null,
  task_end_date: null,
  duration_hours: "",
  duration_minutes: "",
});

const CreateGoalFromTemplate: FunctionComponent = () => {
  const { userInfo,isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as { projectID?: any; projectName?: string };

  const employeeID = String(userInfo?.employee_id || "");
  // const isAdmin = checkIsAdmin(userInfo);
  const today = new Date().toISOString().split("T")[0];

  // ── Goal fields ──
  const [projects, setProjects] = useState<Option[]>([]);
  const [selectedProject, setSelectedProject] = useState<Option | null>(
    state?.projectID
      ? { key: String(state.projectID), name: state.projectName || "" }
      : null,
  );

  const [allPods, setAllPods] = useState<any[]>([]);
  const [selectedPod, setSelectedPod] = useState<Option | null>(null);

  // Templates — selected pod ke hisab se pod_goal_templates API se aate hain
  const [podTemplates, setPodTemplates] = useState<any[]>([]); // raw API data (tasks + checklists ke saath)
  const [templateOptions, setTemplateOptions] = useState<TemplateOption[]>([]);
  const [selectedTemplate, setSelectedTemplate] =
    useState<TemplateOption | null>(null);
  const [clearTemplate,setClearTemplate] = useState(false)
  const [goalTitle, setGoalTitle] = useState("");
  const [description, setDescription] = useState("");
  const [startDate, setStartDate] = useState<string | null>(null);
  const [whatBuilding, setWhatBuilding] = useState("");

  const [extAgencies, setExtAgencies] = useState<Option[]>([]);
  const [extAgenciesLoading, setExtAgenciesLoading] = useState(false);
  const [selectedAgency, setSelectedAgency] = useState<Option | null>(null);

  const [screens, setScreens] = useState<Option[]>([]);
  const [selectedScreen, setSelectedScreen] = useState<Option | null>(null);

  const [skillOptions, setSkillOptions] = useState<Option[]>([]);
  const [selectedSkills, setSelectedSkills] = useState<any[]>([]);

  // ── Tasks ──
  const [parsedTasks, setParsedTasks] = useState<any[]>([]);
  const [taskAssignees, setTaskAssignees] = useState<{
    [taskId: string]: TaskAssigneeState;
  }>({});
  const [taskChecklists, setTaskChecklists] = useState<{
    [taskId: string]: TaskChecklistState;
  }>({});
  const [taskSkills, setTaskSkills] = useState<{ [taskId: string]: Option[] }>(
    {},
  );
  const [taskNotes, setTaskNotes] = useState<{ [taskId: string]: string }>({});
  const [employees, setEmployees] = useState<Option[]>([]);

const { loading: employeesLoading } = useQuery(EMPLOYEES_BY_AGENCY_ID, {
  fetchPolicy: "no-cache",
  variables: { agency_id: AGENCY_ID },
  onCompleted: (res: any) => {
    const list = res?.employees_by_agency_id?.employees || [];
    setEmployees(
      list
        .map((e: any) => ({
          key: String(e.employee_id),
          name: `${e.first_name || ""} ${e.last_name || ""}`.trim(),
        }))
        .sort((a: Option, b: Option) =>
          a.name.localeCompare(b.name, undefined, { sensitivity: "base" }),
        ),
    );
  },
});

  // ── Derived ──
  const selectedPodData = allPods.find(
    (p: any) => String(p.pod_id) === selectedPod?.key,
  );
  const goalMembers: Option[] = (selectedPodData?.members || [])
    .map((m: any) => ({
      key: String(m.employee_id),
      name: `${m.first_name || ""} ${m.last_name || ""}`.trim(),
    }))
    .sort((a: Option, b: Option) =>
      a.name.localeCompare(b.name, undefined, { sensitivity: "base" }),
    );

  const finalGoalMembers: Option[] = (() => {
  const map = new Map<string, Option>();
  goalMembers.forEach((m) => map.set(m.key, m));
  Object.values(taskAssignees).forEach((a) => {
    if (a.employee_id && !map.has(a.employee_id)) {
      map.set(a.employee_id, { key: a.employee_id, name: a.employee_name });
    }
  });
  return Array.from(map.values());
})(); 

  const showAgency = showAgencyForPod(selectedPod?.name || "");
  const showScreen = showScreenForTemplate(selectedTemplate);
  const isEnhancement =
    (selectedTemplate?.tag || "").toLowerCase() === "enhancement" ||
    (selectedTemplate?.name || "").toLowerCase() === "enhancement"; // TODO: tag value confirm karo
  const isDuplicateTask = (task: any) => Boolean(task?.isDuplicate);

  // ───────────────────────────── Queries ─────────────────────────────
  const { loading: projectsLoading } = useQuery(PROJECTS_BY_EMP_ID, {
    fetchPolicy: "no-cache",
    variables: { emp_id: employeeID || "1000004", organization_id: ORGANIZATION_ID },
    onCompleted: (data: any) => {
      setProjects(
        data?.projects_by_emp_id?.map((p: any) => ({
          key: String(p.id),
          name: p.name,
        })) || [],
      );
    },
  });

  const { loading: podsLoading } = useQuery(PODS_DATA_ATTENDANCE, {
    fetchPolicy: "no-cache",
    variables: { agency_id: AGENCY_ID, start_date: today, end_date: today },
    onCompleted: (res: any) => {
      const pods = res?.pods_data?.data || [];
      // Admin ko saare pods, baaki ko sirf wahi jisme wo member hai
      const visible = isAdmin
        ? pods
        : pods.filter((p: any) =>
            (p.members || []).some(
              (m: any) => String(m.employee_id) === employeeID,
            ),
          );
      const visiblePods =  visible?.filter((it:any) => it?.pod_name !== "All Pods" )
      setAllPods(visiblePods);
    },
  });

  const { loading: skillLoading } = useQuery(GET_ALL_SKILLS, {
    fetchPolicy: "no-cache",
    onCompleted: (res: any) => {
      const result = res?.get_all_skills?.skills;
      setSkillOptions(
        result?.map((s: any) => ({ key: s.id, name: s?.skill_name })) || [],
      );
    },
  });

  const [getScreens, { data: screensData, loading: screensLoading }] =
    useLazyQuery(SCREENS_BY_PROJECT, { fetchPolicy: "no-cache" });

  const templateTagsNotAllowed = [
    "bug-fix",
    "enhancements",
    "training-issue",
  ];

  const [getTemplates, { loading: templatesLoading }] = useLazyQuery(
    POD_GOAL_TEMPLATES,
    {
      fetchPolicy: "no-cache",
      onCompleted: (res: any) => {
        const list = res?.pod_goal_templates?.goal_templates || [];
        setPodTemplates(list);
        setTemplateOptions(
          list.map((t: any) => ({
            key: String(t.id),
            name: t.name,
            tag: t.tag || "",
          })).filter((it:any) => !templateTagsNotAllowed?.includes(it?.tag)),
        );
        setSelectedTemplate(null)
      },
      onError: (e: ApolloError) => showError(e.message),
    },
  );


  const [createPodGoalCustom, { loading: createLoading }] = useMutation(
    CREATE_POD_GOAL_CUSTOM,
    { fetchPolicy: "no-cache" },
  );

  // ─────────────────────── External agencies (supabase) ───────────────────────
  const fetchExtAgencies = useCallback(async () => {
    setExtAgenciesLoading(true);
    try {
      const { data, error } = await getSupabaseExt()
        .from("agency")
        .select("agency_id, name, status")
        .eq("status", "Active");
      if (!error && data) {
        setExtAgencies(
          data.map((row: any) => ({
            key: String(row.agency_id),
            name: row.name,
          })),
        );
      }
    } finally {
      setExtAgenciesLoading(false);
    }
  }, []);

  // Agency list tabhi fetch hogi jab agency field dikhni ho
  useEffect(() => {
    if (showAgency && extAgencies.length === 0) fetchExtAgencies();
    if (!showAgency) setSelectedAgency(null);
  }, [showAgency, extAgencies.length, fetchExtAgencies]);

  // Screens project-wise, sirf jab screen field dikhni ho
  useEffect(() => {
    if (showScreen && selectedProject?.key) {
      getScreens({ variables: { project_id: Number(selectedProject.key) } });
    }
    if (!showScreen) setSelectedScreen(null);
  }, [showScreen, selectedProject?.key, getScreens]);

  useEffect(() => {
    if (screensData?.screens_by_project) {
      setScreens(
        screensData.screens_by_project.map((s: any) => ({
          key: String(s.id),
          name: s.name,
        })),
      );
    } else {
      setScreens([]);
    }
  }, [screensData]);

  // ───────────────────────── Pod → templates, Template → tasks ─────────────────────────
  const resetTasks = () => {
    setParsedTasks([]);
    setTaskAssignees({});
    setTaskChecklists({});
    setTaskSkills({});
    setTaskNotes({});
  };

  const initTasks = (tasks: any[]) => {
    const assignees: { [k: string]: TaskAssigneeState } = {};
    const checklists: { [k: string]: TaskChecklistState } = {};
    const skills: { [k: string]: Option[] } = {};
    const notes: { [k: string]: string } = {};

    tasks.forEach((task: any) => {
      const key = String(task.id);
      assignees[key] = emptyAssignee();
      const cl: TaskChecklistState = {};
      (task.checklist_items || []).forEach((item: any, i: number) => {
        cl[i] = isAgentChecklistItem(item.kind);
      });
      checklists[key] = cl;
      skills[key] = [];
      notes[key] = "";
    });

    setParsedTasks(tasks);
    setTaskAssignees(assignees);
    setTaskChecklists(checklists);
    setTaskSkills(skills);
    setTaskNotes(notes);
  };

  // Pod change -> templates dobara laao, purana template/tasks clear
  useEffect(() => {
    setSelectedTemplate(null);
    setTemplateOptions([]);
    setPodTemplates([]);
    resetTasks();
    if (selectedPod?.key) {
      getTemplates({ variables: { pod_id: Number(selectedPod.key) } });
    }
  }, [selectedPod?.key]);

  // Template select -> usi API response se tasks + checklists map karo
  useEffect(() => {
    resetTasks();
    if (!selectedTemplate?.key) return;
    const tpl = podTemplates.find((t: any) => String(t.id) === selectedTemplate.key);
    const tasks = [...(tpl?.tasks || [])]
      .sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0))
      .map((t: any) => ({
        id: t.id,
        title: t.name,
        tag: t.tag,
        doer: t.doer,
        sequence: t.sequence,
        associated_goal_ids: t.associated_goal_ids,
        checklist_items: [...(t.checklists || [])]
          .sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0))
          .map((c: any) => ({
            id: c.id,
            kind: c.kind,
            checklist_name: c.name,
            status: c.status,
            ticked: false,
          })),
      }));
    initTasks(tasks);
  }, [selectedTemplate?.key, podTemplates]);

  // ───────────────────────────── Handlers ─────────────────────────────
  const handleSelectProject = (key: string, name: string) => {
    setSelectedProject({ key: String(key), name });
    setSelectedScreen(null);
  };

  const handleSelectPod = (key: string, name: string) => {
    setSelectedPod({ key: String(key), name });
    // Pod badalne par pod-dependent cheezein reset
    setSelectedAgency(null);
    setTaskAssignees((prev) => {
      const next: typeof prev = {};
      Object.keys(prev).forEach((k) => {
        next[k] = { ...prev[k], employee_id: "", employee_name: "" };
      });
      return next;
    });
    setClearTemplate(true)
  };


  const handleSelectTemplate = (key: string, name: string) => {
    const tpl = templateOptions.find((t) => t.key === String(key));
    // id, name, tag teeno store hote hain
    if(tpl?.key){
    setSelectedTemplate({ key: String(key), name, tag: tpl?.tag || "" });
    }else{
    setSelectedTemplate(null);
    }
    setClearTemplate(false)
  };

  const handleDuplicateTask = (sourceTask: any) => {
    const sourceKey = String(sourceTask.id);
    const duplicateId = `duplicate-${sourceKey}-${Date.now()}`;

    const duplicateTask = {
      ...sourceTask,
      id: duplicateId,
      isDuplicate: true,
      duplicateOf: sourceKey,
      checklist_items: (sourceTask.checklist_items || []).map((item: any) => ({
        ...item,
        ticked: false,
      })),
    };

    setParsedTasks((prev) => {
      let lastRelatedIndex = -1;
      prev.forEach((t: any, i: number) => {
        if (
          String(t.id) === sourceKey ||
          (t.isDuplicate && String(t.duplicateOf) === sourceKey)
        ) {
          lastRelatedIndex = i;
        }
      });
      if (lastRelatedIndex === -1) return prev;
      const next = [...prev];
      next.splice(lastRelatedIndex + 1, 0, duplicateTask);
      return next;
    });

    setTaskAssignees((prev) => ({ ...prev, [duplicateId]: emptyAssignee() }));
    setTaskChecklists((prev) => ({ ...prev, [duplicateId]: {} }));
    setTaskSkills((prev) => ({ ...prev, [duplicateId]: [] }));
    setTaskNotes((prev) => ({ ...prev, [duplicateId]: "" }));
  };

  const handleRemoveDuplicateTask = (task: any) => {
    const id = String(task.id);
    setParsedTasks((prev) => prev.filter((t: any) => String(t.id) !== id));
    const drop = (setter: any) =>
      setter((prev: any) => {
        const next = { ...prev };
        delete next[id];
        return next;
      });
    drop(setTaskAssignees);
    drop(setTaskChecklists);
    drop(setTaskSkills);
    drop(setTaskNotes);
  };

  const handleTaskAssigneeChange = (
    taskKey: string,
    field: keyof TaskAssigneeState,
    value: string | null,
  ) => {
    setTaskAssignees((prev) => ({
      ...prev,
      [taskKey]: { ...prev[taskKey], [field]: value } as TaskAssigneeState,
    }));
  };

  const handleTaskNoteChange = (taskKey: string, value: string) => {
    setTaskNotes((prev) => ({ ...prev, [taskKey]: value }));
  };

  // Hours 0–12, minutes 0–59, digits only
  const handleDurationChange = (
    taskKey: string,
    field: "duration_hours" | "duration_minutes",
    raw: string,
  ) => {
    const digitsOnly = raw.replace(/[^0-9]/g, "");
    if (digitsOnly === "") {
      handleTaskAssigneeChange(taskKey, field, "");
      return;
    }
    const num = parseInt(digitsOnly, 10);
    if (field === "duration_minutes" && num > 59) return;
    if (field === "duration_hours" && num > 12) return;
    handleTaskAssigneeChange(taskKey, field, String(num));
  };

  const handleSelectSkills = (key: any, name: any, type: any) => {
    if (key === "all") {
      setSelectedSkills(name === true ? [] : skillOptions);
      return;
    }
    setSelectedSkills((prev) =>
      prev.some((item) => item.key == key)
        ? prev.filter((item) => item.key != key)
        : [...prev, { key, name, type }],
    );
  };

  const handleRemoveSkill = (key: string) => {
    // Agar ye skill kisi task me use ho rahi hai to pehle wahan se hatao
    const usedInTask = Object.values(taskSkills).some((list) =>
      (list || []).some((s) => String(s.key) === String(key)),
    );
    if (usedInTask) {
      showError(
        "This skill is being used in one or more tasks. Please remove it from tasks first.",
      );
      return;
    }
    setSelectedSkills((prev) => prev.filter((item) => item.key !== key));
  };

  const handleSelectTaskSkill = (
    taskKey: string,
    key: any,
    name: any,
    type: any,
  ) => {
    if (key === "all") {
      setTaskSkills((prev) => ({
        ...prev,
        [taskKey]: name === true ? [] : selectedSkills,
      }));
      return;
    }
    setTaskSkills((prev) => {
      const current = prev[taskKey] || [];
      const exists = current.some((item) => item.key == key);
      const updated = exists
        ? current.filter((item) => item.key != key)
        : [...current, { key, name, type }];
      return { ...prev, [taskKey]: updated };
    });
  };

  const handleRemoveTaskSkill = (taskKey: string, key: string) => {
    setTaskSkills((prev) => ({
      ...prev,
      [taskKey]: (prev[taskKey] || []).filter((item) => item.key !== key),
    }));
  };

  // ───────────────────────────── Submit ─────────────────────────────
  const formatTaskTime = (hours: string, minutes: string) => {
    const hh = String(parseInt(hours || "0", 10)).padStart(2, "0");
    const mm = String(parseInt(minutes || "0", 10)).padStart(2, "0");
    return `${hh}:${mm}:00`;
  };

  const handleSubmit = async () => {
    // ── Goal level validation ──
    if (!selectedProject?.key) return showError("Please select a project");
    if (!selectedPod?.key) return showError("Please select a pod");
    if (!selectedTemplate?.key) return showError("Please select a template");
    if (!goalTitle.trim()) return showError("Please enter a goal title");
    if (showAgency && !selectedAgency?.key)
      return showError("Please select an agency");
    if (!startDate) return showError("Please select a start date");
    if (isEnhancement && !whatBuilding.trim())
      return showError("Please enter the scope");
    // if (selectedSkills.length < 1)
    //   return showError("Please select at least one goal skill");
    if (finalGoalMembers.length < 1)
      return showError("This pod has no members to add to the goal");
    if (parsedTasks.length < 1)
      return showError("No tasks found for the selected template");

    // ── Task level validation ──
    for (const task of parsedTasks) {
      const taskKey = String(task.id);
      const assignee = taskAssignees[taskKey];

      if (!assignee?.employee_id)
        return showError(`Please assign a member to "${task.title}"`);
      if (!assignee.task_start_date)
        return showError(`Please select a start date for "${task.title}"`);
    const start = new Date(assignee.task_start_date);
    if (Number.isNaN(start.getTime()))
      return showError(`Please select valid dates for "${task.title}"`);
// (keep the existing "start < goal start date" check below this)
      const hours = Number(assignee.duration_hours || 0);
      const minutes = Number(assignee.duration_minutes || 0);
      if (!Number.isInteger(hours) || hours < 0 || hours > 12)
        return showError(`Please enter valid hours (0-12) for "${task.title}"`);
      if (!Number.isInteger(minutes) || minutes < 0 || minutes > 59)
        return showError(
          `Please enter valid minutes (0-59) for "${task.title}"`,
        );
      if (hours === 0 && minutes === 0)
        return showError(`Please enter a duration for "${task.title}"`);
    }

    const buildTaskPayload = (task: any) => {
      const taskKey = String(task.id);
      const assignee = taskAssignees[taskKey];
      const taskTime = formatTaskTime(
        assignee.duration_hours,
        assignee.duration_minutes,
      );

      return {
        // Template task = apni id, duplicate task = jis task ko + kiya uski id
        tasks_static_id: isDuplicateTask(task)
          ? Number(task.duplicateOf)
          : Number(task.id),
        employee_id: parseInt(assignee.employee_id),
        start_datetime: `${assignee.task_start_date}T00:00:00Z`,
        // duration yahin se calculate hoti hai (start -> start + HH:MM)
        end_datetime: `${assignee.task_start_date}T${taskTime}Z`,
        skill_ids: (taskSkills[taskKey] || []).map((s) => parseInt(s.key)),
        task_note: taskNotes[taskKey] ?? "",
      };
    };

    // Original 7 template tasks -> task_assignees
    const taskAssigneesPayload = parsedTasks
      .filter((t: any) => !isDuplicateTask(t))
      .map(buildTaskPayload);

    // + se bane tasks (8th, 9th...) -> duplicate_tasks
    const duplicateTasksPayload = parsedTasks
      .filter((t: any) => isDuplicateTask(t))
      .map(buildTaskPayload);

    const lastTaskDate = parsedTasks
      .map((t: any) => taskAssignees[String(t.id)]?.task_start_date)
      .filter(Boolean)
      .sort()
      .pop();

    const variables = {
      input: {
        project_id: parseInt(selectedProject.key),
        pod_id: parseInt(selectedPod.key),
        template_tag: selectedTemplate.tag,
        goal_title: goalTitle.trim(),
        description,
        start_date: `${startDate}T00:00:00Z`,
        end_date: lastTaskDate ? `${lastTaskDate}T23:59:59Z` : null,
        skill_ids: selectedSkills.map((s: any) => parseInt(s.key)),
        goal_members: finalGoalMembers.map((m) => parseInt(m.key)),
        created_by: parseInt(employeeID),
        task_assignees: taskAssigneesPayload,
        duplicate_tasks: duplicateTasksPayload,
        // tasks: NAHI bhejna (wo sirf bina-template custom goal ke liye hai)
      },
    };

try {
  const res = await createPodGoalCustom({ variables });
  const result = res.data?.create_pod_goal_custom; // pehle create_pod_goal tha
  if (result?.status_code === 200 || result?.status_code === 201) {
    showSuccess(result?.message || "Goal created successfully");
    navigate(-1);
  } else {
    showError(result?.message || "Failed to create goal");
  }
} catch (err) {
  if (err instanceof ApolloError) showError(err.message);
}

  };

  // ───────────────────────────── Render ─────────────────────────────
  const taskLocked = false;

  return (
    <>
      <div
        id="cts-respon-p-dv"
        className="w-full relative min-h-screen overflow-hidden block flex-row items-start justify-center flex-wrap content-start py-40 px-20 mq991:p-8 mq575:p-4 box-border text-left text-base font-manrope"
      >
        <div className="flex-1 flex flex-col items-start justify-start gap-6">
          <BreadCumb clientName={selectedProject?.name || ""} />

          <div className="self-stretch flex flex-row items-center justify-start gap-[5px] text-2xl">
            <img
              className="w-6 relative h-6 overflow-hidden shrink-0 cursor-pointer dark-white-img"
              alt=""
              src={backArrow}
              onClick={() => navigate(-1)}
            />
            <h3 className="m-0 flex-1 relative text-inherit font-bold font-inherit mq450:text-base dark:text-white">
              Create Goal
            </h3>
          </div>

          <div className="self-stretch rounded-lg bg-surface-bg-primary dark:bg-slate-800 flex flex-col items-start justify-start gap-6 p-8 mq575:p-3">
            {/* ── Goal Details ── */}
            <div className="grid gap-4 assigntask-card-dv self-stretch">
              <div className="grid gap-4 inner-assigntask-card-dv self-stretch">
                <h5 className="my-0 self-stretch text-lg dark:text-white font-bold">
                  Goal Details
                </h5>

                <div className="grid grid-cols-4 mq1275:grid-cols-3 mq950:grid-cols-2 mq575:grid-cols-1 gap-[8px] min-w-full">
                  <SearchableInputsDropdown
                    key={`project-${selectedProject?.key || "none"}`}
                    label="Project Name*"
                    initialValue={selectedProject?.name || ""}
                    placeHolder="Select project"
                    options={projects}
                    dontselectlastValue={true}
                    onSelect={handleSelectProject}
                  />
                  <SearchableInputsDropdown
                    label="Pod*"
                    initialValue={selectedPod?.name || ""}
                    placeHolder="Select pod"
                    options={allPods.map((p: any) => ({
                      key: String(p.pod_id),
                      name: p.pod_name,
                    }))}
                    dontselectlastValue={true}
                    onSelect={handleSelectPod}
                  />
                  <SearchableInputsDropdown
                    key={`template-${selectedPod?.key || "none"}`}
                    label="Template*"
                    // initialValue={selectedTemplate?.name || ""}
                    placeHolder={selectedPod ? "Select template" : "Select pod first"}
                    options={templateOptions}
                    dontselectlastValue={true}
                    onSelect={handleSelectTemplate}
                    clearSelected={clearTemplate}
                  />
                  <InputsNew
                    label="Goal Title*"
                    type="text"
                    contentPlaceholder="Goal Title"
                    value={goalTitle}
                    onChange={(e) => setGoalTitle(e.target.value)}
                  />

                  {showAgency && (
                    <SearchableInputsDropdown
                      label="Agency Name*"
                      initialValue={selectedAgency?.name || ""}
                      placeHolder="Select agency"
                      options={extAgencies}
                      dontselectlastValue={true}
                      onSelect={(key: string, name: string) =>
                        setSelectedAgency({ key: String(key), name })
                      }
                    />
                  )}

                  {showScreen && (
                    <SearchableInputsDropdown
                      key={`screen-${selectedProject?.key || "none"}`}
                      label="Screen Name"
                      initialValue={selectedScreen?.name || ""}
                      placeHolder="Select screen"
                      options={screens}
                      dontselectlastValue={true}
                      onSelect={(key: string, name: string) =>
                        setSelectedScreen({ key: String(key), name })
                      }
                    />
                  )}

                  <div className="flex flex-col items-start justify-start gap-[8px] startdate-inner-input">
                    <DateSelector
                      label="Start Date*"
                      selectedDate={startDate}
                      onChange={(date: string | null) => setStartDate(date)}
                      nothideParsedValue={true}
                    />
                  </div>
                </div>

                <div className="self-stretch">
                  <InputsNew
                    contentPlaceholder="Goal Description"
                    label="Description"
                    type="textarea"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>

                {isEnhancement && (
                  <div className="self-stretch enhancement-textrea-input-dv grid gap-4">
                    <div className="grid gap-1">
                      <label className="self-stretch relative font-semibold darkblue-blg-item dark:text-white">
                        What we are building — and what we are not
                      </label>
                    </div>
                    <div className="self-stretch">
                      <InputsNew
                        contentPlaceholder="The Scope"
                        label="The Scope*"
                        type="textarea"
                        value={whatBuilding}
                        onChange={(e) => setWhatBuilding(e.target.value)}
                      />
                    </div>
                  </div>
                )}

                {/* Goal Skills */}
                {/* <div className="grid grid-cols-4 mq1275:grid-cols-3 mq950:grid-cols-2 mq575:grid-cols-1 gap-[8px] min-w-full">
                  <div className="grid">
                    <InputsDropdownMultipleSearchSelect
                      label="Skills*"
                      placeHolder="Choose"
                      options={skillOptions}
                      onSelect={handleSelectSkills}
                      inputType="checkbox"
                      checkedItems={selectedSkills}
                    />
                    {selectedSkills.length > 0 && (
                      <div className="reportmulselect-blg flex-1 w-full cts-flex1-remd contents flex-col items-start justify-start text-left text-sm mq825:max-w-[100%] text-text-text-primary font-body-reg min-w-full">
                        <div className="inner-reportmulselect-blg inner-reportmulselect-item items-start justify-start text-left text-sm mq825:max-w-[100%] text-text-text-primary font-body-reg mt-2">
                          {selectedSkills.map((ss: any) => (
                            <div
                              key={ss?.key}
                              className="reportmulselect-blg-dv rounded-radius-md1 overflow-hidden flex flex-row items-center justify-start gap-[8px] inner-item-select-dv border-[1px] border-solid border-surface-border dark:bg-slate-700"
                            >
                              <div className="relative text-sm font-body-xs-semi-bold text-colors-text-black text-left inline-block dark:text-white">
                                {ss?.name}
                              </div>
                              <img
                                className="h-4 w-4 relative overflow-hidden shrink-0 cursor-pointer"
                                loading="lazy"
                                alt="Remove"
                                src={closeDowpDowniconimg}
                                onClick={() => handleRemoveSkill(ss.key)}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div> */}
              </div>
            </div>

            {/* ── Goal Members (pod ke members) ── */}
            <div className="grid gap-4 assigntask-card-dv self-stretch">
              <div className="grid gap-4 inner-assigntask-card-dv self-stretch">
                <div className="self-stretch flex flex-col gap-3">
                  <label className="text-sm font-semibold dark:text-white">
                    Goal Members*
                  </label>
                  {!selectedPod ? (
                    <p className="my-0 text-sm text-gray-500 dark:text-gray-400">
                      Select a pod to see its members.
                    </p>
                  ) : (
                    <div className="grid grid-cols-4 mq1275:grid-cols-3 mq950:grid-cols-2 mq575:grid-cols-1 gap-2">
                      {finalGoalMembers.map((m) => (
                        <div
                          key={m.key}
                          className="flex items-center gap-2 p-3 rounded-md member-list-item bg-gray-50 dark:bg-slate-700"
                        >
                          <img src={aiAgenticon} className="w-3 h-3" alt="" />
                          <span className="text-sm dark:text-white truncate flex-1">
                            {m.name}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="self-stretch border-t border-gray-200 dark:border-gray-700" />

            {/* ── Assign Tasks ── */}
            <div className="grid gap-4 assigntask-card-dv self-stretch">
              <div className="grid gap-4 inner-assigntask-card-dv self-stretch">
                <div className="grid gap-2">
                  <h5 className="my-0 self-stretch text-lg dark:text-white font-bold">
                    Assign Tasks
                  </h5>
                  <p className="my-0 text-sm text-gray-500 dark:text-gray-400">
                    Assign a member, dates, duration, skills and description for
                    each task of the selected template.
                  </p>
                </div>

                {!selectedTemplate && (
                  <p className="my-0 text-sm text-gray-500 dark:text-gray-400">
                    Select a template to load its tasks.
                  </p>
                )}

                <div className="self-stretch grid gap-4">
                  {parsedTasks.map((task: any, idx: number) => {
                    const isAgent = isAgentTask(task);
                    const taskKey = String(task.id);
                    const assignee = taskAssignees[taskKey];

                    return (
                      <div
                        key={taskKey}
                        className={`p-4 rounded-lg border ${
                          isAgent
                            ? "border-purple-200 dark:border-purple-800 bg-purple-50 dark:bg-purple-900/10"
                            : "border-[1px] border-solid border-surface-border inner-assigntask-card-dv"
                        }`}
                      >
                        <div className="flex items-center gap-3 mb-4">
                          <div className="w-7 h-7 rounded-full bg-gray-100 dark:bg-slate-700 border-[1px] border-solid border-surface-border text-[#2b2b2b] dark:text-white text-xs flex items-center justify-center flex-shrink-0 font-bold">
                            {idx + 1}
                          </div>
                          <div className="flex-1">
                            <div className="flex items-center gap-2 flex-wrap">
                              <span className="text-sm font-semibold dark:text-white">
                                {task.title}
                              </span>
                              {/* {isAgent && (
                                <span className="inline-flex items-center gap-1 text-xs bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-300 px-2 py-0.5 rounded font-medium">
                                  🤖 Agent Slot
                                </span>
                              )} */}
                            </div>
                          </div>

                          <div className="flex items-center gap-2 shrink-0">
                            {isDuplicateTask(task) ? (
                              <button
                                type="button"
                                aria-label="Remove duplicated task"
                                title="Remove duplicated task"
                                onClick={() => handleRemoveDuplicateTask(task)}
                                className="text-gray-400 cta-red transition mt-0.5 ml-4 flex-shrink-0 pt-1"
                              >
                                <svg
                                  className="w-5 h-5"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M6 18L18 6M6 6l12 12"
                                  ></path>
                                </svg>
                              </button>
                            ) : (
                              <button
                                type="button"
                                aria-label={`Duplicate task ${task.title}`}
                                title="Duplicate task"
                                onClick={() => handleDuplicateTask(task)}
                                className="cursor-pointer flex flex-col items-start justify-start p-[10px] plus-task-btn taskdash-plush-img rounded"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                >
                                  <path
                                    d="M8 3.5V12.5"
                                    stroke="#fff"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M12.5 8H3.5"
                                    stroke="#fff"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </button>
                            )}
                          </div>
                        </div>

                        <div className="grid grid-cols-4 mq1400:grid-4 mq1275:grid-cols-3 mq950:grid-cols-2 mq575:grid-cols-1 mt-[8px] gap-[8px] min-w-full">
                          <SearchableInputsDropdown
                            disableDropdown={taskLocked}
                            key={`assign-${taskKey}-${selectedPod?.key || ""}`}
                            label="Assign To"
                            initialValue={assignee?.employee_name || ""}
                            placeHolder="Select member"
                            options={employees}
                            dontselectlastValue={true}
                            onSelect={(key: string, name: string) => {
                              handleTaskAssigneeChange(
                                taskKey,
                                "employee_id",
                                key,
                              );
                              handleTaskAssigneeChange(
                                taskKey,
                                "employee_name",
                                name,
                              );
                            }}
                          />
                          <DateSelector
                            disabled={taskLocked}
                            key={`start-${taskKey}`}
                            label="Start Date"
                            selectedDate={assignee?.task_start_date || null}
                            onChange={(date: string | null) => {
                              handleTaskAssigneeChange(taskKey, "task_start_date", date);
                              handleTaskAssigneeChange(taskKey, "task_end_date", date);
                            }}
                            minDate={
                              startDate ? new Date(startDate) : undefined
                            }
                            nothideParsedValue={true}
                          />
                          <DateSelector
                            disabled={true}
                            key={`end-${taskKey}`}
                            label="End Date"
                            selectedDate={assignee?.task_end_date || null}
                            onChange={(date: string | null) =>
                              handleTaskAssigneeChange(
                                taskKey,
                                "task_end_date",
                                date,
                              )
                            }
                            minDate={
                              assignee?.task_start_date
                                ? new Date(assignee.task_start_date)
                                : startDate
                                  ? new Date(startDate)
                                  : undefined
                            }
                            nothideParsedValue={true}
                          />

                          <div className="flex flex-col gap-[8px] duration-input-item-dv">
                            <label className="text-xs font-semibold dark:text-white">
                              Duration
                            </label>
                            <div className="flex items-center gap-2">
                              <div className="py-2.5 cursor-pointer w-12 self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] h-[21px] tabelin-input-dv rounded-radius-md bg-text-text-tertiary dark:text-white dark:bg-slate-700 overflow-hidden flex flex-row items-center justify-start px-[15px] border-[1px] border-solid border-surface-border">
                                <input
                                  disabled={taskLocked}
                                  type="text"
                                  inputMode="numeric"
                                  maxLength={2}
                                  placeholder="HH"
                                  value={assignee?.duration_hours ?? ""}
                                  onChange={(e) =>
                                    handleDurationChange(
                                      taskKey,
                                      "duration_hours",
                                      e.target.value,
                                    )
                                  }
                                  className="w-full border-none outline-none focus-none text-center text-sm dark:text-white bg-dark-item"
                                />
                              </div>
                              <div className="py-2.5 cursor-pointer w-12 self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] h-[21px] tabelin-input-dv rounded-radius-md bg-text-text-tertiary dark:text-white dark:bg-slate-700 overflow-hidden flex flex-row items-center justify-start px-[15px] border-[1px] border-solid border-surface-border">
                                <input
                                  disabled={taskLocked}
                                  type="text"
                                  inputMode="numeric"
                                  maxLength={2}
                                  placeholder="MM"
                                  value={assignee?.duration_minutes ?? ""}
                                  onChange={(e) =>
                                    handleDurationChange(
                                      taskKey,
                                      "duration_minutes",
                                      e.target.value,
                                    )
                                  }
                                  className="w-full border-none outline-none focus-none text-center text-sm dark:text-white bg-dark-item"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* <div className="mt-3 pt-3 border-t border-gray-100 dark:border-gray-600">
                          <div className="grid grid-cols-4 mq1400:grid-4 mq1275:grid-cols-3 mq950:grid-cols-2 mq575:grid-cols-1 gap-[8px] min-w-full">
                            <div className="grid">
                              <InputsDropdownMultipleSearchSelect
                                label="Skills"
                                placeHolder="Choose"
                                options={selectedSkills}
                                onSelect={(key: any, name: any, type: any) =>
                                  handleSelectTaskSkill(taskKey, key, name, type)
                                }
                                inputType="checkbox"
                                checkedItems={taskSkills[taskKey] || []}
                                disableDropdown={taskLocked}
                              />

                              {(taskSkills[taskKey]?.length ?? 0) > 0 && (
                                <div className="reportmulselect-blg flex-1 w-full cts-flex1-remd contents flex-col items-start justify-start text-left text-sm mq825:max-w-[100%] text-text-text-primary font-body-reg min-w-full">
                                  <div className="inner-reportmulselect-blg inner-reportmulselect-item items-start justify-start text-left text-sm mq825:max-w-[100%] text-text-text-primary font-body-reg mt-2">
                                    {taskSkills[taskKey].map((ss: any) => (
                                      <div
                                        key={ss?.key}
                                        className="reportmulselect-blg-dv rounded-radius-md1 overflow-hidden flex flex-row items-center justify-start gap-[8px] inner-item-select-dv border-[1px] border-solid border-surface-border dark:bg-slate-700"
                                      >
                                        <div className="relative text-sm font-body-xs-semi-bold text-colors-text-black text-left inline-block dark:text-white">
                                          {ss?.name}
                                        </div>
                                        <img
                                          className="h-4 w-4 relative overflow-hidden shrink-0 cursor-pointer"
                                          loading="lazy"
                                          alt="Remove"
                                          src={closeDowpDowniconimg}
                                          onClick={() =>
                                            handleRemoveTaskSkill(taskKey, ss.key)
                                          }
                                        />
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div> */}

                        <div className="mt-3 pt-3 border-t border-gray-100 dark:border-gray-600">
                          <label className="text-xs font-semibold dark:text-white mb-1 block">
                            Task Description
                          </label>
                          <textarea
                            disabled={taskLocked}
                            value={taskNotes[taskKey] ?? ""}
                            onChange={(e) =>
                              handleTaskNoteChange(taskKey, e.target.value)
                            }
                            placeholder="Add a description for this task..."
                            rows={2}
                            className="w-full text-sm rounded-radius-md border-[1px] border-solid border-surface-border p-2 dark:bg-slate-700 dark:text-white outline-none"
                          />
                        </div>

                        {task.checklist_items?.length > 0 && (
                          <div className="mt-3 pt-3 border-t border-gray-100 dark:border-gray-600">
                            <p className="my-0 text-xs font-semibold dark:text-white mb-2">
                              Checklist:
                            </p>
                            <div className="grid gap-1">
                              {task.checklist_items.map(
                                (item: any, cidx: number) => {
                                  const isAgentCheck = isAgentChecklistItem(
                                    item.kind,
                                  );
                                  return (
                                    <label
                                      key={item.id ?? cidx}
                                      className="flex items-center gap-2 cursor-pointer py-[5px] px-[5px] border-[1px] border-solid border-surface-border"
                                    >
                                      {isAgentCheck ? (
                                        <span className="text-xs flex-shrink-0 agent-bg-dv">
                                          Agent
                                        </span>
                                      ) : (
                                        <span className="text-xs flex-shrink-0 human-bg-dv">
                                          Human
                                        </span>
                                      )}
                                      <span className="text-xs text-gray-700 dark:text-gray-300">
                                        {item.checklist_name}
                                      </span>
                                      {isAgentCheck && (
                                        <span className="text-xs text-[#2B2B2B] italic">
                                          (agent verifies)
                                        </span>
                                      )}
                                    </label>
                                  );
                                },
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>

                <div className="self-stretch flex flex-row items-center justify-end gap-[8px]">
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="cursor-pointer bg-white py-2.5 h-[44px] px-[42px] btn-text-purple rounded-radiuscomponent-button box-border flex flex-row items-center justify-center gap-[12px] border-[2px] border-solid border-surface-primary-surface hover:bg-gainsboro-100"
                  >
                    <span className="relative text-sm font-body-xs-semi-bold dark:text-white">
                      Cancel
                    </span>
                  </button>
                  <button
                    type="button"
                    onClick={handleSubmit}
                    disabled={createLoading || templatesLoading}
                    className="cursor-pointer [border:none] py-2.5 h-[44px] px-[42px] bg-surface-primary-surface rounded-radiuscomponent-button flex flex-row items-center justify-center gap-[12px] hover:bg-dodgerblue disabled:opacity-50"
                  >
                    <span className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary">
                      Create Goal
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {(projectsLoading ||
        podsLoading ||
        skillLoading ||
        screensLoading ||
        extAgenciesLoading ||
        templatesLoading ||
        createLoading || employeesLoading) && <Loader />}
    </>
  );
};

export default CreateGoalFromTemplate;